import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminVideoManager.css";

const AdminVideoManager = () => {
  const [videos, setVideos] = useState([]);

  const [form, setForm] = useState({
    title: "",
    description1: "",
    description2: "",
    email: "",
    buttonText: "Fullscreen",
    active: 1,
  });

  const [videoFile, setVideoFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [editId, setEditId] = useState(null);

  // FETCH
  const fetchVideos = async () => {
    const res = await axios.get("/api/videos");
    setVideos(res.data);
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  // INPUT CHANGE
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // VIDEO PREVIEW
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setVideoFile(file);

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  // RESET FORM
  const resetForm = () => {
    setForm({
      title: "",
      description1: "",
      description2: "",
      email: "",
      buttonText: "Fullscreen",
      active: 1,
    });
    setVideoFile(null);
    setPreview(null);
    setEditId(null);
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(form).forEach((key) => data.append(key, form[key]));
    if (videoFile) data.append("video", videoFile);

    if (editId) {
      await axios.put(`/api/videos/${editId}`, data);
    } else {
      await axios.post("/api/videos", data);
    }

    fetchVideos();
    resetForm();
  };

  // EDIT
  const handleEdit = (v) => {
    setForm(v);
    setEditId(v.id);
    setPreview(`${BASE_URL}/uploads/videofilm/${v.video}`);
  };

  // DELETE
  const handleDelete = async (id) => {
    await axios.delete(`/api/videos/${id}`);
    fetchVideos();
  };

  return (
    <div className="video-admin">
      <h2>Home Video Manager</h2>

      <form onSubmit={handleSubmit} className="video-form">
        <input name="title" value={form.title} onChange={handleChange} placeholder="Title" required />

        <textarea name="description1" value={form.description1} onChange={handleChange} placeholder="Description 1" />

        <textarea name="description2" value={form.description2} onChange={handleChange} placeholder="Description 2" />

        <input name="email" value={form.email} onChange={handleChange} placeholder="Email" />

        <input name="buttonText" value={form.buttonText} onChange={handleChange} />

        <select name="active" value={form.active} onChange={handleChange}>
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>

        <input type="file" accept="video/*" onChange={handleVideoChange} />

        {/* VIDEO PREVIEW */}
        {preview && (
          <video src={preview} controls className="preview-video" />
        )}

        <button type="submit">{editId ? "Update" : "Add"} Video</button>
        <button type="button" onClick={resetForm}>Reset</button>
      </form>

      {/* GRID */}
      <div className="video-grid">
        {videos.map((v) => (
          <div key={v.id} className="video-card">
            <video
              src={`${BASE_URL}/uploads/videofilm/${v.video}`}
              controls
            />

            <h4>{v.title}</h4>
            <p>{v.description1}</p>

            <div className="actions">
              <button onClick={() => handleEdit(v)}>Edit</button>
              <button onClick={() => handleDelete(v.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminVideoManager;